import { Container } from './styles';

interface IContentProps {
  children: React.ReactNode;
}
export function Content({ children }: IContentProps) {
  return <Container id="layout__content">{children}</Container>;
}
